// extracted by mini-css-extract-plugin
export var label = "_jy-2";
export var slideContainer = "_jy-0";
export var slider = "_jy-1";